export default "__VITE_ASSET__DixelqRR__"